module.exports = __webpack_public_path__ + "media/ping.24ab9209.wav";